import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  event: '',
  isReady: false
};

const tradeEventSlice = createSlice({
  name: 'tradeEvent',
  initialState,
  reducers: {
    setTradeEvent(state, action) {
      state.event = action.payload;
    },
    setTradeEventStatus(state, action) {
      state.isReady = action.payload;
    }
  }
});

export const { setTradeEvent, setTradeEventStatus } = tradeEventSlice.actions;

const tradeEventReducer = tradeEventSlice.reducer;
export default tradeEventReducer;
